import { render, staticRenderFns } from "./ExecucaoManualSyncPropostas.vue?vue&type=template&id=4ccfc6a4&"
import script from "./ExecucaoManualSyncPropostas.vue?vue&type=script&lang=js&"
export * from "./ExecucaoManualSyncPropostas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports